// Option A, phase 3 (docs/reference/zone_and_settings_changes.md §4): screens match a
// zone's figures by its ZoneKey; the name is only the label. The counter endpoints give
// every entry its `zone_key`; the flow's zones (GET /flows) carry `ZoneKey`.

// The figures for each card zone: { cardName: entry | undefined }. Looked up by key
// first, by name only for an entry without a key.
export function countersForCards(cardZones, counters) {
  const byKey = new Map()
  for (const entry of Object.values(counters || {})) {
    if (entry && entry.zone_key != null) byKey.set(entry.zone_key, entry)
  }
  const out = {}
  for (const [name, zone] of Object.entries(cardZones || {})) {
    const key = zone && zone.ZoneKey
    out[name] = (key != null && byKey.get(key)) || (counters || {})[name]
  }
  return out
}

// Directional (crossing) counters keyed by the zone's CURRENT name from the flow,
// whatever name the entry arrived under; entries for one zone are summed.
export function storeCountersByCardName(cardZones, storeCounters) {
  const nameByKey = new Map()
  for (const [name, zone] of Object.entries(cardZones || {})) {
    if (zone && zone.ZoneKey != null) nameByKey.set(zone.ZoneKey, name)
  }
  const out = {}
  for (const [name, entry] of Object.entries(storeCounters || {})) {
    if (!entry) continue
    const label = (entry.zone_key != null && nameByKey.get(entry.zone_key)) || name
    const prev = out[label]
    out[label] = {
      zone_in_count: (prev ? prev.zone_in_count : 0) + (entry.zone_in_count || 0),
      zone_out_count: (prev ? prev.zone_out_count : 0) + (entry.zone_out_count || 0),
      zone_type: entry.zone_type || (prev && prev.zone_type) || '',
    }
  }
  return out
}
